import { FC } from "react"
import Sections from "../../defines/Sections"
import { ArrowDownFullIcon } from "../../icons/ArrowDownFullIcon"
import { ArrowUpFullIcon } from "../../icons/ArrowUpFullIcon"

export type DashboardSectionProps = {
  /**
   * Selecting section
   */
  selectedSection: any
  /**
   * Function for selecting section
   */
  setSelectedSection: any
  /**
   * Section title
   */
  sectionTitle: string
  /**
   * Section name
   */
  section: any
  children: any
}

export const DashboardSection: FC<DashboardSectionProps> = ({
  selectedSection,
  setSelectedSection,
  sectionTitle,
  section,
  children,
}) => {
  return (
    <div className="max-w-sm w-full">
      <div
        className="relative mb-3 rounded h-10 w-full bg-white shadow-lg"
        onClick={() => {
          if (selectedSection === section) {
            setSelectedSection(null)
          } else {
            setSelectedSection(section)
          }
        }}
      >
        <div className="pt-3 pl-3 text-xs font-semibold">{sectionTitle}</div>
        <div className="absolute top-4 right-5">
          {selectedSection === section ? (
            <ArrowUpFullIcon />
          ) : (
            <ArrowDownFullIcon />
          )}
        </div>
      </div>
      {selectedSection === section && <div className="mb-5">{children}</div>}
    </div>
  )
}
